import React from 'react';
import ThumbHtmlView from './CommissionHtml';
import ThumbReactView from './Commission';
const CommissionThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(ThumbHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(ThumbReactView, props);
};
CommissionThumbView.displayName = 'CommissionThumbView';
export default CommissionThumbView;
